import { Injectable } from '@angular/core';
import { StateService } from '@uirouter/angular';

@Injectable()
export class ForumResolvesService {

    constructor(private stateService: StateService) {
    }

    async security(project: any, ProjectModel: any): Promise<any> {
        return ProjectModel.checkPermission(project, 'forum');
    }

    browseTour(TourService: any) {
        return TourService.setTour('discussionBrowseCtrl');
    }

    readTour(TourService: any) {
        return TourService.setTour('discussionHomeCtrl');
    }

    async getForum(forumId: string, ForumService: any, project: any): Promise<any> {
        try {
            const data = await ForumService.forumSummary(forumId);
            
            //Check if the forum belongs to a different project
            if (project.id != data.refId && data.section != 'mailman') {
                var _params = {unixName: project.unixName};
                this.stateService.go('home.project.summary.forum', _params,{
                    notify:true,
                    // prevent reload of the current state
                    reload:false,
                    inherit:true
                });
            }
            return data;
        } catch (response) {
            throw response;
        }
    }
}
